module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/app/components/accordion/accordion.component.html
// module id = ../../../../../src/app/components/accordion/accordion.component.html
// module chunks = main